module.exports = __webpack_public_path__ + "static/media/evercellCarousel3.ef2496b0.png";